import apiPaths from '../api-paths.js';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.STAFF }/plenipotentiaries${ query }`);
  },
};
